import { FilterBar, FilterChip, FilterMenu, FilterSearch } from '../../../shared/ui/filter-bar';
import type {
  ISourceFilters,
  TSourceAuthFilter,
  TSourceStateFilter,
} from '../../../entities/source';

const STATE_OPTIONS: readonly { value: TSourceStateFilter; label: string }[] = [
  { value: 'active', label: 'Receiving' },
  { value: 'disabled', label: 'Refusing' },
];

const AUTH_OPTIONS: readonly { value: TSourceAuthFilter; label: string }[] = [
  { value: 'checked', label: 'Checked' },
  { value: 'unchecked', label: 'No check' },
];

interface ISourceFiltersBarProps {
  filters: ISourceFilters;
  onFilters: (next: ISourceFilters) => void;
  /** Undefined while it cannot be exact: more than one page, or the issues not read yet. */
  hasProblemsCount: number | undefined;
}

export const SourceFiltersBar = ({
  filters,
  onFilters,
  hasProblemsCount,
}: ISourceFiltersBarProps) => {
  // Any change of what is asked for starts back at the first page.
  const set = (patch: Partial<ISourceFilters>) =>
    onFilters({ ...filters, ...patch, cursor: undefined });

  return (
    <FilterBar>
      <FilterMenu
        label="State"
        value={filters.state}
        options={STATE_OPTIONS}
        onChange={(state) => set({ state })}
      />
      <FilterMenu
        label="Auth"
        value={filters.auth}
        options={AUTH_OPTIONS}
        onChange={(auth) => set({ auth })}
      />
      <FilterChip
        on={filters.hasProblems}
        onClick={() => set({ hasProblems: !filters.hasProblems || undefined })}
        aria-pressed={Boolean(filters.hasProblems)}
      >
        Has problems{typeof hasProblemsCount === 'number' ? ` · ${hasProblemsCount}` : ''}
      </FilterChip>
      <FilterSearch placeholder="Find a source" value={filters.q} onChange={(q) => set({ q })} />
    </FilterBar>
  );
};
